import React, { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Form from '../../../components/form/public/Form';
import usePublicForm from '../../../hooks/api/form/usePublicForm';
import LoadingSpinner from '../../../components/layout/loadingSpinner/LoadingSpinner';
import { getSecuritySection, SecurityModel, SecuritySections } from '../../../models/security/security';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { useHistory } from 'react-router';
import { FallbackPage } from '../../../components/layout/navbar/Navbar';

const FormPreviewPage: FC = () => {
  const [formSecurity, setFormSecurity] = useState<SecurityModel | null>(null);
  const { formId } = useParams<{ formId?: string | undefined }>();
  const { form, organization, setFormId, isLoading } = usePublicForm();
  const security = useSelector((state: RootState) => state.organization.organization?.security);
  const history = useHistory();

  useEffect(() => {
    if (formId) {
      setFormId(formId);
    }
  }, [formId]);

  useEffect(() => {
    if (security) {
      setFormSecurity(getSecuritySection(security, SecuritySections.FORM));
    }
    if (formSecurity && !formSecurity?.read) {
      history.push(FallbackPage);
    }
  }, [security, formSecurity]);

  return (
    <React.Fragment>
      {(isLoading || !form || !organization) && <LoadingSpinner />}
      {!isLoading && form && organization && (
        <div className="page-content">
          <Form organization={organization} form={form} showShareModal={true}></Form>
        </div>
      )}
    </React.Fragment>
  );
};

export default FormPreviewPage;
